define('SC.HorizonThemeExtension.ItemRelations.SC.Configuration', [
  'SC.HorizonThemeExtension.Common.Configuration'
], function ThemeExtensionItemRelations(Configuration) {
  'use strict';

  return {
    loadModule: function loadModule() {
      var overallConfiguration = Configuration.getOverallConfiguration();
      if (
        overallConfiguration.bxSliderDefaults &&
        overallConfiguration.bxSliderDefaults.slideWidth
      ) {
        overallConfiguration.bxSliderDefaults.slideWidth = 533;
        overallConfiguration.bxSliderDefaults.maxSlides = 3;
      }
    }
  };
});
